import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as BulletInActive } from 'assets/svg/icon-bullet-in-active.svg'

function IconBulletInActive(props: IconProps): JSX.Element {
  const title = 'icon-bullet-in-active'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <BulletInActive {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconBulletInActive
